module.exports = __webpack_public_path__ + "img/ic-upload-2.ca0bf322.svg";